// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabImgs_comp___VjVL"};